<template>
  <div>
    <div class="row">
      <div class="col text-left">
        <div class="alert alert-dark" v-if="idCopiado !== ''">
          <strong>Id copiado</strong> {{ idCopiado }}
        </div>
      </div>
    </div>
    <div
      v-if="tab && itens.length > 0"
      class="d-flex justify-content-start"
      style="margin-bottom: 5px"
      role="group"
      aria-label="Basic example"
    >
      <button
        type="button"
        style="margin-right: 5px; zoom: 0.7"
        class="btn btn-sm btn-light"
        @click="selecionarTodos()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-check-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
          <path
            d="M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.235.235 0 0 1 .02-.022z"
          />
        </svg>
      </button>
      <button
        type="button"
        style="margin-right: 5px; zoom: 0.7"
        class="btn btn-sm btn-light"
        @click="limparSelecionados(true)"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-square"
          viewBox="0 0 16 16"
        >
          <path
            d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z"
          />
        </svg>
      </button>
    </div>
    <div
      v-for="item in eventosRenderizados"
      :key="item.__grupo ? item.__grupoKey : item._id || item.id"
      :item="item"
    >
      <div v-if="item.__grupo" class="eventosGrupoTitulo">
        {{ item.nome }}
      </div>
      <div v-else class="list-group-item">
        <div class="row">
        <div class="col text-left">
          <div>
            <div class="d-flex justify-content-between">
              <h6 style="margin-top: 2px">
                <small v-if="retornaSite() !== 'Share'">
                  {{ item.dataHora.toString().padStart(2, "0") }}:{{
                    item.dataMinuto.toString().padStart(2, "0")
                  }}
                  -
                </small>
                {{ item.nome }}
              </h6>
              <div
                v-if="retornaSite() !== 'Share'"
                @click="alterarListViewFuncoes(item)"
                class="eventoResumoDados"
                :class="{
                  'cursor-pointer':
                    retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp',
                }"
              >
                <div>
                  <small
                    v-if="
                      retornaSite() == 'Weddbets' &&
                      item.usuarioCriacaoJoin &&
                      item.usuarioCriacaoJoin.length > 0
                    "
                    >{{ item.usuarioCriacaoJoin[0].nome }} / </small
                  ><small>{{ situacao[item.situacao] }}</small
                  ><small
                    v-if="
                      $global.servidores_sip()[
                        item.servidorTipo + '_' + item.servidor
                      ]
                    "
                    class="text-success"
                  >
                    /
                    {{
                      $global.servidores_sip()[
                        item.servidorTipo + "_" + item.servidor
                      ].nome
                    }}
                    <span
                      v-if="
                        retornaSite() == 'Weddbets' ||
                        retornaSite() == 'ShareApp'
                      "
                      >({{ item.canais }})</span
                    ></small
                  >
                </div>
                <div class="eventoResumoSource" v-if="sourceEventoLabel(item)">
                  {{ sourceEventoLabel(item) }}
                </div>
              </div>
              <h6
                v-if="
                  retornaSite() == 'Share' &&
                  item.usuarioCriacaoJoin &&
                  item.usuarioCriacaoJoin.length > 0
                "
              >
                <small>{{ item.usuarioCriacaoJoin[0].email }}</small>
              </h6>
            </div>

            <div class="d-flex justify-content-between">
              <div
                class="d-flex align-items-center justify-content-start eventoAcoesEsquerda"
                v-if="retornaSite() !== 'Share'"
              >
                <input
                  @change="$emit('selecionar', $event, item)"
                  type="checkbox"
                  style="
                    margin-left: 10px;
                    margin-right: 18px;
                    margin-top: 5px;
                    transform: scale(1.3);
                    -webkit-transform: scale(1.3);
                  "
                  v-model="item.selecionado"
                />
                <button
                  type="button"
                  class="btn btn-sm eventoAcaoBotao"
                  :class="{
                    'btn-outline-dark': !item.sofaScoreId,
                    'btn-dark': item.sofaScoreId,
                  }"
                  data-target="#dialogEdit"
                  data-toggle="modal"
                  @click="$emit('editarItem', item._id)"
                >
                  SOFA
                </button>
                <button
                  type="button"
                  class="btn btn-sm eventoAcaoBotao"
                  :class="{
                    'btn-outline-dark': !item.williamHillId,
                    'btn-dark': item.williamHillId,
                  }"
                  @click="$emit('williamhillVincular', item._id)"
                >
                  WILL
                </button>
                <svg
                  class="eventoTransmissaoIcone"
                  :class="{
                    eventoTransmissaoIconeAtivo: eventoTransmitindo(item),
                  }"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  :title="
                    eventoTransmitindo(item)
                      ? 'Transmissao ativa'
                      : 'Transmissao inativa'
                  "
                  role="img"
                  :aria-label="
                    eventoTransmitindo(item)
                      ? 'Transmissao ativa'
                      : 'Transmissao inativa'
                  "
                >
                  <path
                    fill-rule="evenodd"
                    d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
                  />
                </svg>
                <svg
                  v-if="eventoTemAgendamento(item)"
                  class="eventoAgendamentoIcone"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                  title="Transmissao automatica agendada"
                  role="img"
                  aria-label="Transmissao automatica agendada"
                >
                  <path
                    d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                  />
                </svg>
                <button
                  type="button"
                  class="btn btn-sm eventoAcaoBotao"
                  :class="{
                    'btn-outline-dark':
                      item.usuarioCriacaoJoin[0]._id !== idUsuario,
                    'btn-dark': item.usuarioCriacaoJoin[0]._id == idUsuario,
                  }"
                  data-target="#dialogEdit"
                  data-toggle="modal"
                  @click="$emit('editarItem', item._id)"
                  v-if="
                    item.usuarioCriacaoJoin &&
                    item.usuarioCriacaoJoin.length > 0 &&
                    retornaSite() == '7live'
                  "
                >
                  {{ item.usuarioCriacaoJoin[0].nome }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm eventoAcaoBotao"
                  @click="$emit('aoVivo', item._id)"
                  v-if="item.situacao == 1"
                >
                  AO VIVO
                </button>
                <button
                  type="button"
                  class="btn btn-outline-danger btn-sm eventoAcaoBotao"
                  @click="$emit('encerrar', item._id)"
                  v-if="item.situacao == 3"
                >
                  Encerrar
                </button>
              </div>
              <div>
                <div
                  class="eventoAcoesDireita"
                  :class="{
                    'd-none':
                      listViewFuncoes[item._id] &&
                      listViewFuncoes[item._id] !== 'normal',
                  }"
                >
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    data-target="#dialogEdit"
                    data-toggle="modal"
                    @click="$emit('editarItem', item._id)"
                  >
                    Editar
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    @click="$emit('transmitItem', item._id)"
                  >
                    Transmitir
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    style="display: none"
                    @click="$emit('fonteItem', item.linkFonte)"
                    v-if="retornaSite() !== 'ShareApp'"
                  >
                    Fonte
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    @click="$emit('excluirItem', item)"
                  >
                    Excluir
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    @click="copyId(item._id)"
                    v-if="retornaSite() !== '7live'"
                  >
                    Id
                  </button>
                  <button
                    type="button"
                    class="btn btn-outline-primary btn-sm eventoAcaoBotao"
                    @click="abrirEvento(item)"
                    v-if="retornaSite() == '7live'"
                  >
                    Player
                  </button>
                </div>
                <div
                  :class="{
                    'd-none':
                      !listViewFuncoes[item._id] ||
                      listViewFuncoes[item._id] !== 'player',
                  }"
                >
                  <div
                    class="d-flex"
                    v-if="
                      retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp'
                    "
                  >
                    <div
                      v-for="(canal, keyCanal) in [
                        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16,
                        17, 18, 19, 20, 21,
                      ]"
                      :key="keyCanal"
                      :item="canal"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-primary"
                        style="zoom: 0.7; min-width: 30px"
                        :class="{ 'mr-2': keyCanal != 20 }"
                        @click="abrirEventoPlayer(item, keyCanal)"
                      >
                        {{ keyCanal }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ListEventos",
  components: {},
  props: {
    itens: Array,
    tab: { type: Boolean, default: false },
    agrupamento: { type: String, default: "sem" },
    transmissionStates: { type: Object, default: () => ({}) },
  },
  methods: {
    retornaSite() {
      return this.$site;
    },
    eventoTemAgendamento(item) {
      if (!item.onStart || !item.onEnd) {
        return false;
      }

      const inicio = new Date(item.onStart);
      const fim = new Date(item.onEnd);

      return (
        !Number.isNaN(inicio.getTime()) &&
        !Number.isNaN(fim.getTime()) &&
        inicio < fim
      );
    },
    eventoTransmitindo(item) {
      const eventoId = item && (item._id || item.id);

      if (!eventoId) {
        return false;
      }

      const state = this.transmissionStates[eventoId.toString()];
      return !!state && state.active === true;
    },
    limparSelecionados(emit) {
      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        if (this.itens[indiceItem].selecionado == true) {
          this.$set(this.itens[indiceItem], "selecionado", false);

          if (emit) {
            this.$emit("selecionar", {}, this.itens[indiceItem]);
          }
        }
      }
    },
    selecionarTodos() {
      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        if (this.itens[indiceItem].selecionado == false) {
          this.$set(this.itens[indiceItem], "selecionado", true);
          this.$emit("selecionar", {}, this.itens[indiceItem]);
        }
      }
    },
    copyId(texto) {
      var call = this;
      this.$copyText(texto).then(
        function (e) {
          call.idCopiado = texto;
          console.log(e);
        },
        function (e) {
          console.log(e);
        }
      );
    },
    abrirEvento(evento) {
      window.open(
        "/view/" + evento._id + "?view=clean",
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    abrirEventoPlayer(evento, canal) {
      window.open(
        "/view/" + evento._id + "?view=clean&canal=" + canal,
        "newwindow_" + Date.now(),
        "scrollbars=1,width=450,height=500",
        true
      );
    },
    alterarListViewFuncoes(item) {
      if (
        this.retornaSite() !== "Weddbets" &&
        this.retornaSite() !== "ShareApp"
      ) {
        return;
      }

      if (
        !this.listViewFuncoes[item._id] ||
        this.listViewFuncoes[item._id] == "normal"
      ) {
        this.listViewFuncoes[item._id] = "player";
      } else if (this.listViewFuncoes[item._id] == "player") {
        this.listViewFuncoes[item._id] = "normal";
      }

      this.$forceUpdate();
    },
    sourceEventoLabel(item) {
      const labels = this.sourceEventoLabels(item);

      if (labels.length == 0) {
        return "-";
      }

      return labels.join(" | ");
    },
    sourceEventoLabels(item) {
      const sources = item.remoteSources || [];
      const source =
        sources.find(function (sourceItem) {
          return sourceItem.transmissaoPadrao === true;
        }) ||
        sources[0] ||
        null;

      if (!source) {
        return [];
      }

      const sourceNome =
        source.sourceNome || source.hostname || source.sourceKey || "";
      const video =
        source.videoLabel ||
        source.deviceLabel ||
        source.videoId ||
        source.deviceId ||
        "";
      const label = [sourceNome, video].filter(function (value) {
        return value !== "";
      }).join(" / ");

      return label !== "" ? [label] : [];
    },
    grupoEventoNome(item) {
      if (this.agrupamento == "competicao") {
        return item.competicao || "Sem competicao";
      }

      if (this.agrupamento == "source") {
        const labels = this.sourceEventoLabels(item);
        return labels.length > 0 ? labels.join(" | ") : "Sem source";
      }

      if (this.agrupamento == "servidor") {
        const servidor =
          this.$global.servidores_sip()[
            item.servidorTipo + "_" + item.servidor
          ];

        return servidor && servidor.nome ? servidor.nome : "Sem servidor";
      }

      return "";
    },
  },
  computed: {
    idUsuario: function () {
      return this.$sessao.usuario._id;
    },
    eventosRenderizados: function () {
      if (this.agrupamento == "sem") {
        return this.itens;
      }

      const grupos = [];
      const indiceGrupos = {};

      for (var indiceItem = 0; indiceItem < this.itens.length; indiceItem++) {
        const item = this.itens[indiceItem];
        const nomeGrupo = this.grupoEventoNome(item);

        if (!indiceGrupos[nomeGrupo]) {
          indiceGrupos[nomeGrupo] = {
            nome: nomeGrupo,
            itens: [],
          };
          grupos.push(indiceGrupos[nomeGrupo]);
        }

        indiceGrupos[nomeGrupo].itens.push(item);
      }

      grupos.sort(function (a, b) {
        return a.nome.localeCompare(b.nome, "pt-BR");
      });

      const linhas = [];

      for (var indiceGrupo = 0; indiceGrupo < grupos.length; indiceGrupo++) {
        linhas.push({
          __grupo: true,
          __grupoKey:
            "grupo_" + this.agrupamento + "_" + grupos[indiceGrupo].nome,
          nome: grupos[indiceGrupo].nome,
        });

        for (
          var indiceGrupoItem = 0;
          indiceGrupoItem < grupos[indiceGrupo].itens.length;
          indiceGrupoItem++
        ) {
          linhas.push(grupos[indiceGrupo].itens[indiceGrupoItem]);
        }
      }

      return linhas;
    },
  },
  mounted() {},
  data: function () {
    return {
      situacao: {
        1: "Previsto",
        2: "Invisivel",
        3: "Ao Vivo",
        4: "Finalizado",
      },
      idCopiado: "",
      listViewFuncoes: {},
    };
  },
};
</script>

<style>
.eventoResumoDados {
  font-size: 11px;
  line-height: 1.15;
  margin-left: 10px;
  min-width: 160px;
  text-align: right;
}

.eventoAcoesEsquerda,
.eventoAcoesDireita {
  align-items: center;
}

.eventoAcoesDireita {
  display: flex;
  justify-content: flex-end;
}

.eventoAcaoBotao {
  border-radius: 2px;
  font-size: 9px;
  line-height: 1;
  margin-right: 4px;
  min-height: 18px;
  padding: 2px 5px;
  white-space: nowrap;
}

.eventoAcoesDireita .eventoAcaoBotao:last-child {
  margin-right: 0;
}

.eventoResumoSource {
  align-items: center;
  color: #6c757d;
  display: flex;
  font-size: 10px;
  justify-content: flex-end;
  margin-top: 2px;
}

.eventoTransmissaoIcone {
  align-self: center;
  color: #868e96;
  flex: 0 0 13px;
  height: 13px;
  margin-right: 6px;
  width: 13px;
}

.eventoTransmissaoIconeAtivo {
  color: #28a745;
}

.eventoAgendamentoIcone {
  align-self: center;
  color: #f59e0b;
  flex: 0 0 13px;
  height: 13px;
  margin-right: 10px;
  width: 13px;
}

.eventosGrupoTitulo {
  background: #f1f3f5;
  border-left: 3px solid #6c757d;
  color: #495057;
  font-size: 12px;
  font-weight: 600;
  margin-top: 8px;
  padding: 5px 8px;
  text-align: left;
}
</style>
